const React = require('react')
const IconEllipsis = require('shared/assets/svg/ellipsis-horizontal.svg')

module.exports = {
  ellipsis: <IconEllipsis width="13px" height="3px" />,
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/context-menu/index.js